import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'

@Component({
  selector: 'form-supplier-search',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatOption,
    MatSelect,
  ],
  templateUrl: './form-supplier-search.component.html',
  styleUrl: './form-supplier-search.component.scss',
})
export class FormSupplierSearchComponent implements OnInit, OnChanges {
  constructor(private formBuilder: FormBuilder) {}

  formSearch: FormGroup = new FormGroup({})

  @Output() responseSearch = new EventEmitter()
  @Input() search: any = { type: '', search: '' }
  @Input() listSearch: any[] = []

  listType: any[] = []
  listActive: any[] = [
    { value: '', description: 'Todos' },
    { value: 'S', description: 'Ativos' },
    { value: 'N', description: 'Inativos' },
  ]

  ngOnInit() {
    this.createForm()
    this.treatmentList()
  }

  ngOnChanges() {
    this.updateSearch()
    this.treatmentList()
  }

  updateSearch() {
    this.formSearch.get('search')?.setValue(this.search.search ?? '')
    this.formSearch.get('searchType')?.setValue(this.search.type ?? '')
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      searchType: [''],
      search: [''],
      active: [''],
    })
  }

  treatmentList() {
    this.listType = []
    if (this.listSearch.length > 0) {
      for (let i = 0; i < this.listSearch.length; i++) {
        const item = this.listSearch[i]
        if (item.visible) {
          this.listType.push(item)
        }
      }
      if (this.listType.length > 0) {
        this.formSearch.get('searchType')?.setValue(this.listType[0].id)
        this.formSearch.get('search')?.enable()
        this.formSearch.get('searchType')?.enable()
      } else {
        this.formSearch.get('search')?.disable()
        this.formSearch.get('searchType')?.disable()
      }
    }
  }

  sendSearch(search = false) {
    const data = {
      type: this.formSearch.get('searchType')?.value ?? '',
      search: this.formSearch.get('search')?.value.trim() ?? '',
      active: this.formSearch.get('active')?.value ?? '',
    }
    if (!search) {
      this.formSearch.get('search')?.setValue('')
      this.formSearch.get('active')?.setValue('')
    }
    this.responseSearch.emit({ search: search, data: search ? data : {} })
  }

  checkSearch() {
    if (
      this.formSearch.get('search')!.value.trim().length > 0 &&
      this.formSearch.get('searchType')!.value
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('search')?.value
    if (input.trim().length > 3) {
      // if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }
}
